import { FeedTag } from "@pages/Keyword/utils/types";
import { FeedSection } from "@pages/Section/utils/types";

import { NewsletterFactory } from "./NewsletterFactory";

export type ArticleNewsletterProps = {
  sections: FeedSection[];
  tags: FeedTag[];
  displayNewVersionNewsletter?: boolean;
  className?: string;
};
export default function ArticleNewsletter({
  className,
  tags,
  sections,
  displayNewVersionNewsletter,
}: ArticleNewsletterProps): React.ReactElement {
  return (
    <div className={className} data-testid="article-newsletter-component">
      <NewsletterFactory
        sections={sections}
        tags={tags}
        displayNewVersionNewsletter={displayNewVersionNewsletter}
      />
    </div>
  );
}
